<template>
    <div class="accordion-group">
        <slot />
    </div>
</template>
<script>

export default {
    data() {
        return {
            /**
             * @type {Array<VueComponent>}
             */
            items: [],
        }
    },

    mounted() {
        this.setItems()
    },

    updated() {
        this.setItems()
    },

    methods: {
        /**
         * Assigns all VueComponents in the default slot to the items array and adds an event
         * handler to capture toggle events. All VueComponents in the default slot should be
         * instances of hh-accordion-item.
         */
        setItems() {
            this.items = this.$slots.default
                .filter(item => item.componentInstance !== undefined)
                .map(item => item.componentInstance)

            this.items.forEach(item => item.$on('toggle', () => this.toggleItems(item)))
        },

        /**
         * Closes any open components if the supplied component is active. It does this by setting
         * the component's active property to false.
         *
         * @param {VueComponent} currentItem The item which has just emitted its toggle event.
         */
        toggleItems(currentItem) {
            if (currentItem.active) {
                this.items
                    .filter(item => item !== currentItem)
                    .forEach(item => item.active = false)
            }
        },
    },
}

</script>
